module.exports = __webpack_public_path__ + "img/icon-chevron-down-dark.1a1f3ad7.svg";